<template>
  <vehicle-detail :is-edit="false"/>
</template>

<script>
    import VehicleDetail from './components/VehicleDetail';
    export default {
        name: "CreateVehicle",
        components: { VehicleDetail },
    }
</script>

<style scoped>

</style>
